import styled from 'styled-components';

import { breakpoints, Col, Grid, Row } from '@notino/react-styleguide-v20';

import { defaultFontSizeCSS } from '@styles/generalStyles';

import { IDeviceSettings } from '../model';

export const BaseCol = styled(Col)<IDeviceSettings>`
  display: ${({ mobile: { visible } }) => (visible ? 'flex' : 'none')};
  padding-right: ${({ mobile: { paddingRight } }) => paddingRight}rem;
  padding-left: ${({ mobile: { paddingLeft } }) => paddingLeft}rem;

  ${defaultFontSizeCSS};

  @media (min-width: ${breakpoints.sm}) {
    display: ${({ desktop: { visible } }) => (visible ? 'flex' : 'none')};
    padding-right: ${({ desktop: { paddingRight } }) => paddingRight}rem;
    padding-left: ${({ desktop: { paddingLeft } }) => paddingLeft}rem;
  }
`;

export const StyledGrid = styled(Grid)`
  padding: 0;
  margin: 0;
`;

interface IVisible {
  visible?: boolean;
}

export const StyledRow = styled(Row)<IVisible>`
  display: ${({ visible = true }) => (visible ? 'flex' : 'none')};
  padding: 0;
  margin-top: 0.5rem;
  margin-left: 0;
  margin-right: 0;

  @media (min-width: ${breakpoints.sm}) {
    margin-left: 1rem;
    margin-right: 0;
  }

  @media (min-width: ${breakpoints.md}) {
    margin-left: 1rem;
    margin-right: 1rem;
  }
`;
